module.exports = __webpack_public_path__ + "img/slide1.0dcf23ea.png";